module.exports = __webpack_public_path__ + "static/media/twitter.2312b9ba.png";